export default "__VITE_ASSET__FikMyIvn__"